import { Language, Locale } from "@/services/global-services/models";
import { Dictionary } from "@/utils/Dictionary";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type LocaleStore = {
    loading: boolean;
    availableRegions: Locale[];
    availableLanguages: Dictionary<Language[]>;
    activeRegion: string | null;
    activeLanguage: string | null;
    setLoading: (loading: boolean) => void;
    setAvailableRegions: (regions: Locale[]) => void;
    setAvailableLanguages: (languages: Dictionary<Language[]>) => void;
    setActiveRegion: (region: string) => void;
    setActiveLanguage: (language: string) => void;
};

const useLocaleStore = create<LocaleStore>()(
    persist(
        (set) => ({
            // (set, get) => ({
            loading: true,
            availableRegions: [],
            availableLanguages: {},
            activeRegion: null,
            activeLanguage: null,
            setLoading: (loading: boolean) => set({ loading }),
            setAvailableRegions: (regions: Locale[]) => set({ availableRegions: regions }),
            setAvailableLanguages: (languages: Dictionary<Language[]>) => set({ availableLanguages: languages }),
            setActiveRegion: (region: string) => set({ activeRegion: region }),
            setActiveLanguage: (language: string) => set({ activeLanguage: language }),
        }),
        {
            name: "locale-storage",
            version: 1,
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({ activeLanguage: state.activeLanguage, activeRegion: state.activeRegion }),
        }
    )
);

export default useLocaleStore;
